var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "justify-end": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1000px" },
          model: {
            value: _vm.localDialog,
            callback: function($$v) {
              _vm.localDialog = $$v
            },
            expression: "localDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Voice Type",
                                      rules: _vm.generalRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.local.voiceType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "voiceType", $$v)
                                      },
                                      expression: "local.voiceType"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.languages,
                                      label: "Select Language"
                                    },
                                    model: {
                                      value: _vm.local.language,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "language", $$v)
                                      },
                                      expression: "local.language"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.voiceEffects,
                                      label: "Select Voice Effect"
                                    },
                                    model: {
                                      value: _vm.local.voiceEffect,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "voiceEffect", $$v)
                                      },
                                      expression: "local.voiceEffect"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-textarea", {
                                    attrs: { label: "Voice Text" },
                                    model: {
                                      value: _vm.local.voiceText,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "voiceText", $$v)
                                      },
                                      expression: "local.voiceText"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c("v-divider", { attrs: { vertical: "" } }),
                              _vm._v(" "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Voice Volume",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.voiceVolume,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "voiceVolume", $$v)
                                      },
                                      expression: "local.voiceVolume"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Start Time",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.startTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "startTime", $$v)
                                      },
                                      expression: "local.startTime"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "End Time",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.local.endTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "endTime", $$v)
                                      },
                                      expression: "local.endTime"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Duration (sec)",
                                      type: "number",
                                      min: "0"
                                    },
                                    model: {
                                      value: _vm.local.duration,
                                      callback: function($$v) {
                                        _vm.$set(_vm.local, "duration", $$v)
                                      },
                                      expression: "local.duration"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("h3", [_vm._v("Type of Component")]),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.local.componentType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.local,
                                            "componentType",
                                            $$v
                                          )
                                        },
                                        expression: "local.componentType"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.componentType.threeD,
                                          value: _vm.componentType.threeD
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          label: _vm.componentType.character,
                                          value: _vm.componentType.character
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.save } },
                    [
                      this.saving
                        ? _c(
                            "v-flex",
                            [
                              _c("v-progress-circular", {
                                attrs: { indeterminate: "", color: "primary" }
                              })
                            ],
                            1
                          )
                        : _c("v-flex", [_vm._v("Save")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a5ecd8e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5ecd8e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/add-new/addTts.vue
// module id = null
// module chunks = 